import { createContext, useContext } from "react";

export const PanelContext = createContext(false);
export const usePanelContext = () => useContext(PanelContext);
